import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Home from "./pages/Home";
import About from "./pages/About";
import Journeys from "./pages/Journeys";
import JourneyDetail from "./pages/JourneyDetail";
import Journal from "./pages/Journal";
import JournalDetail from "./pages/JournalDetail";
import Destination from "./pages/Destination";
import Enquire from "./pages/Enquire";
import Admin from "./pages/Admin";
import FlagLoader from "./components/FlagLoader";
import { SiteProvider, useSite } from "./useSite";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const { ready, ofKind } = useSite();
  const [covering, setCovering] = useState(true);
  const loaders = ready ? ofKind("loader") : null;
  const record = loaders?.[0] || null;

  useEffect(() => {
    setCovering(true);
    if (!ready) return undefined;
    const timer = setTimeout(() => setCovering(false), 1800);
    return () => clearTimeout(timer);
  }, [pathname, ready]);

  const enabled = loaders === null || Boolean(record);

  return (
    <>
      {enabled ? (
        <FlagLoader
          active={covering}
          phrase={record?.title || "Please wait.."}
          image={record ? record.image : "/images/loader-pin.png"}
        />
      ) : null}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/journeys" element={<Journeys />} />
        <Route path="/journeys/:slug" element={<JourneyDetail />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalDetail />} />
        <Route path="/destinations/:slug" element={<Destination />} />
        <Route path="/contact" element={<Enquire />} />
        <Route path="/enquire" element={<Enquire />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <SiteProvider>
      <Shell />
    </SiteProvider>
  );
}
